import getIntl from 'Helpers/intl'
import { logAppError, logAppInfo } from 'Helpers/logger'
import {
  abTestState,
  pageState,
  PAGE_STATE_ERROR,
  PAGE_STATE_INITIAL,
  PAGE_STATE_READY,
  pecPlusConfigState,
  fasciaDiNonDisturboState,
  smartPlanningState
} from '../state/page'
import {
  isScheduledSendingState,
  newSenderState,
  oldSenderState
} from '../state/sender'
import { idsState, timeAndCountState } from '../state/campaign'
import {
  getMessageDetails,
  getEmailSendingDetails,
  getSenderInEmailQueue,
  updateSenderInEmailQueue,
  getPecPlusGetPecPlusConfig,
  getTotalSendingTime,
  getAbTestIdByInvio,
  getQueuedEmailRecipients,
  scheduleNow,
  setSendingImmediate,
  setSendingScheduled,
  clearEmailSendingQueue,
  removeRecipientFromEmailSendingQueue,
  simulateSending,
  getSegmentationDetails,
  getABTestConfigByIdAction,
  getNoDisturbConfig,
  removeNoDisturbConfig,
  setNoDisturbConfig,
  updateNoDisturbConfig,
  getSmartPlanningSuggestedDate
} from '../actions/actions'
import {
  manageRecipientsState,
  modalDeleteRecipientsState,
  modalSendingSegmentationState
} from '../state/manageRecipients'
import {
  toastShow,
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_ERROR,
  TOAST_VARIANT_WARNING
} from 'mailup-web-components'

import { pendoTrack } from 'Helpers/pendoTracking'

import { ABTEST_STATUS_WINNER_MESSAGE_DEFINED } from 'Api/beABTestApi'
import moment from 'moment-timezone'
import {
  INPUT_MINUTES_STEP,
  roundToClosestMultiple
} from 'Components/ContentScheduled/recoil/state'
import { STORE_KEY_LIST, storeGet } from 'mailup-react-helpers'
import { getTimeObj } from 'Helpers/dates'
import { MODE_SMART } from 'Constants/index'

export const verifyDateCallback = ({
  set,
  snapshot
}) => async momentTimeZoneDate => {
  return isValidDate(momentTimeZoneDate)
}

const isValidDate = momentTimeZoneDate => {
  // data selezionata in UTC
  const momentUtcDate = momentTimeZoneDate.clone().utc()
  // data e ora corrente
  const baseUtcDate = moment(new Date().toISOString()).utc()
  // const baseUtcDate = moment.tz(zones[timeZone]).utc()
  // i muniti devono essere arrotondati
  const minutes = roundToClosestMultiple(
    +baseUtcDate.format('mm'),
    INPUT_MINUTES_STEP
  )

  baseUtcDate.set('minutes', minutes + INPUT_MINUTES_STEP)
  baseUtcDate.set('seconds', 0)
  // sempre valido
  const validDate = momentUtcDate.isAfter(baseUtcDate)
  if (validDate) {
    return { valid: true } // valido
  } else {
    const validH =
      momentUtcDate.diff(baseUtcDate, 'hours') >= 0 &&
      momentUtcDate.hours() >= baseUtcDate.hours()
    const validM = momentUtcDate.diff(baseUtcDate, 'minutes') >= 0
    const validD =
      momentTimeZoneDate.diff(baseUtcDate, 'days') >= 0 &&
      momentTimeZoneDate.day() >= baseUtcDate.day()
    return { valid: validH && validM && validD, validH, validM, validD } // return true if date is valid
  }
}

export const initCallback = ({ set }) => async idSending => {
  set(pageState, prev => ({
    ...prev,
    loading: true,
    status: PAGE_STATE_INITIAL
  }))

  try {
    const {
      IdMessage: idMessage,
      ExcludeGroups,
      Filtri,
      Groups,
      IdSendStop
    } = await getEmailSendingDetails(idSending)
    const [
      { title },
      { Count: count, Email: email, Name: name },
      { pecConfig, listName },
      idAbTest,
      { EstimatedTime, Queued }
    ] = await Promise.all([
      getMessageDetails(idMessage),
      getSenderInEmailQueue(idSending),
      getPecPlusGetPecPlusConfig(),
      getAbTestIdByInvio(idSending),
      getTotalSendingTime(idSending, idMessage)
    ])

    set(pageState, prev => ({ ...prev, title }))

    set(idsState, prev => ({
      ...prev,
      idMessage,
      idSending,
      idAbTest
    }))

    set(timeAndCountState, prev => ({
      ...prev,
      recipientCount: count,
      estimatedTime: EstimatedTime,
      queued: Queued
    }))

    set(timeAndCountState, prev => ({
      ...prev,
      recipientCount: count,
      estimatedTime: EstimatedTime,
      queued: Queued
    }))

    set(newSenderState, { count, email, name })
    set(oldSenderState, { count, email, name })

    set(pecPlusConfigState, prev => ({
      ...prev,
      isListPecPlus: !!pecConfig,
      statusListPecPlus: pecConfig ? pecConfig.Status : undefined,
      listName
    }))

    if (idAbTest > -1) {
      const abTestDetails = await getABTestConfigByIdAction(idAbTest)
      set(abTestState, prev => ({
        ...prev,
        idAbTest,
        abTestDetails,
        isABTestNotReadyQueue:
          abTestDetails.Info.Stato !== ABTEST_STATUS_WINNER_MESSAGE_DEFINED
      }))
    }

    const {
      groups,
      excludedGroups,
      filters,
      simulationEnabled
    } = await getSegmentationDetails(Groups, ExcludeGroups, Filtri, IdSendStop)

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      groups,
      excludedGroups,
      filters,
      simulationEnabled,
      queued: Queued,
      simulationLoading: false,
      simulationLoaded: false
    }))
  } catch (error) {
    logAppError({
      Component: 'EmailSendingQueueManage',
      Method: 'initCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      status: PAGE_STATE_ERROR
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loaded: true,
    loading: false,
    status: PAGE_STATE_READY
  }))
}

export const getSmartPlanningSuggestedDateCallback = ({
  set,
  snapshot
}) => async isUpdate => {
  set(smartPlanningState, prev => ({
    ...prev,
    smartPlanningDateLoaded: false,
    smartPlanningUpdated: isUpdate
  }))
  try {
    const { idSending } = await snapshot.getPromise(idsState)
    const { smartPlanningDate: oldSuggestedDate } = await snapshot.getPromise(
      smartPlanningState
    )

    const { SuggestedDate, Detail } = await getSmartPlanningSuggestedDate(
      idSending
    )
    if (isUpdate && oldSuggestedDate !== SuggestedDate) {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.QueueStatus.AiPlanningChangedOnRecipients'
        }),
        TOAST_VARIANT_WARNING,
        'AiPlanningChangedOnRecipients'
      )
    }

    set(smartPlanningState, prev => ({
      ...prev,
      smartPlanningDate: SuggestedDate,
      smartPlanningChanged: oldSuggestedDate !== SuggestedDate,
      smartPlanningDateLoaded: true,
      smartPlanningError:
        Detail && Detail.Code === 422
          ? 'NoData'
          : Detail && Detail.Code === 404
          ? 'DataError'
          : undefined
    }))
  } catch (error) {
    set(smartPlanningState, prev => ({
      ...prev,
      smartPlanningDate: '',
      smartPlanningDateLoaded: true,
      smartPlanningError: 'DataError'
    }))
    logAppError({
      appError: error,
      Component: 'sendingWizard',
      Method: 'getSmartPlanningSuggestedDateCallback'
    })
  }
}

export const getTotalSendingTimeCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))

  try {
    const { idMessage, idSending } = await snapshot.getPromise(idsState)

    const [{ Count: count }, { EstimatedTime, Queued }] = await Promise.all([
      getSenderInEmailQueue(idSending),
      getTotalSendingTime(idSending, idMessage)
    ])

    set(timeAndCountState, prev => ({
      ...prev,
      recipientCount: count,
      estimatedTime: EstimatedTime,
      queued: Queued
    }))

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      queued: Queued
    }))
  } catch (error) {
    console.log('@err', error)
    logAppError({
      Component: 'getTotalSendingTimeCallback',
      Method: 'initCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      status: PAGE_STATE_ERROR
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const cleanupCallback = ({ reset }) => () => {
  reset(pageState)
  reset(idsState)
  reset(timeAndCountState)
  reset(pecPlusConfigState)
  reset(manageRecipientsState)
  reset(isScheduledSendingState)
}

export const updateSenderCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  const { name: oldName, email: oldEmail } = await snapshot.getPromise(
    oldSenderState
  )
  const { name: newName, email: newEmail } = await snapshot.getPromise(
    newSenderState
  )
  const { idSending } = await snapshot.getPromise(idsState)

  try {
    await updateSenderInEmailQueue(
      idSending,
      newName,
      newEmail,
      oldName,
      oldEmail
    )
    set(oldSenderState, prev => ({ ...prev, name: newName, email: newEmail }))
  } catch (error) {
    logAppError({
      Component: 'EmailSendingQueueManage',
      Method: 'updateSenderCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      status: PAGE_STATE_ERROR
    }))
  }
  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
}

export const getQueuedEmailRecipientsCallback = ({
  set,
  snapshot
}) => async () => {
  set(manageRecipientsState, prev => ({ ...prev, isSearch: true }))
  const { idSending } = await snapshot.getPromise(idsState)
  const { filterBy, orderBy, pageSize, pageNumber } = await snapshot.getPromise(
    manageRecipientsState
  )

  try {
    const resp = await getQueuedEmailRecipients(idSending, {
      filterBy: filterBy ? "Email.Contains('" + filterBy + "')" : '',
      orderBy,
      pageSize,
      pageNum: pageNumber
      // orderDescending
    })

    set(manageRecipientsState, prev => ({
      ...prev,
      items: resp.Items,
      totalItems: resp.TotalItems
    }))
  } catch (error) {
    logAppError({
      Component: 'EmailSendingQueueManage',
      Method: 'getQueuedEmailRecipientsCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      status: PAGE_STATE_ERROR
    }))
  }
  set(manageRecipientsState, prev => ({ ...prev, isSearch: false }))
}

export const scheduleNowCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  let res = true
  const { idSending } = await snapshot.getPromise(idsState)
  try {
    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'scheduleNowCallback',
      Message: 'Inizio imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })

    await scheduleNow(idSending)

    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'scheduleNowCallback',
      Message: 'Fine imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })
  } catch (error) {
    res = false
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'scheduleNowCallback',
      Message: 'Errore imposta schedulazione immediata invio',
      Data: JSON.stringify({ idSending })
    })
  }

  set(pageState, prev => ({
    ...prev,
    loading: false
  }))
  return res
}

export const sendingScheduleSetScheduleCallback = ({ set, snapshot }) => async (
  dateStart,
  timeZone,
  mode
) => {
  const { idSending } = await snapshot.getPromise(idsState)
  let res = true

  try {
    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Inizio imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZone })
    })
    const planningType = mode ? (mode === MODE_SMART ? 1 : 0) : 0
    await setSendingScheduled(idSending, dateStart, timeZone, planningType)
    if (mode === MODE_SMART) {
      pendoTrack('Smart Scheduling - Email Sending Preview', {})
    }
    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Fine imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart, timeZone })
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'sendingScheduleSetScheduleCallback',
      Message: 'Errore imposta schedulazione invio',
      Data: JSON.stringify({ idSending, dateStart })
    })

    res = false
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  return res
}

export const sendingScheduleSetImmediateCallback = ({
  set,
  snapshot
}) => async () => {
  const { idSending } = await snapshot.getPromise(idsState)
  let res = true

  try {
    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'emailSendingWizardSetImmediateCallback',
      Message: 'Inizio imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })

    await setSendingImmediate(idSending)

    logAppInfo({
      Component: 'EmailSendingQueueManage',
      Method: 'sendingScheduleSetImmediateCallback',
      Message: 'Fine imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'sendingScheduleSetImmediateCallback',
      Message: 'Errore imposta invio sequenziale',
      Data: JSON.stringify({ idSending })
    })

    res = false
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  return res
}

export const deleteRecipientsCallback = ({
  set,
  snapshot,
  reset
}) => async queued => {
  const { idSending } = await snapshot.getPromise(idsState)

  const { idRecipient } = await snapshot.getPromise(modalDeleteRecipientsState)

  try {
    let resp = false

    if (queued === 1) {
      resp = await clearEmailSendingQueue(idSending)
    } else {
      resp = await removeRecipientFromEmailSendingQueue(idSending, idRecipient)
    }

    pendoTrack('Queue preview - recepients delete', {
      idSending: idSending,
      idRecipient: idRecipient
    })

    reset(modalDeleteRecipientsState)
    if (resp) {
      if (queued > 1) {
        toastShow(
          getIntl().formatMessage({
            id: 'Load.Queue.DeleteRecipientFromSendQueueSuccess'
          }),
          TOAST_VARIANT_SUCCESS,
          'DeleteRecipientFromSendQueueSuccess'
        )
      }
    } else {
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.ErrorGeneric'
        }),
        TOAST_VARIANT_ERROR,
        'ErrorGeneric'
      )
    }
    return resp
  } catch (error) {
    logAppError({
      Component: 'EmailSendingQueueManage',
      Method: 'deleteRecipientsCallback',
      appError: error
    })
    toastShow(
      getIntl().formatMessage({
        id: 'Load.Alerts.ErrorGeneric'
      }),
      TOAST_VARIANT_ERROR,
      'ErrorGeneric'
    )
  }
}

export const sendingSegmentationSimulateCallback = ({
  set,
  snapshot
}) => async () => {
  const { groups, excludedGroups, filters } = await snapshot.getPromise(
    modalSendingSegmentationState
  )
  const { idMessage, idSending } = await snapshot.getPromise(idsState)

  const { queued } = await snapshot.getPromise(timeAndCountState)
  set(modalSendingSegmentationState, prev => ({
    ...prev,
    simulationLoading: true
  }))

  try {
    const { ToBeQueued } = await simulateSending(
      idSending,
      groups,
      excludedGroups,
      filters
    )

    const simulationDiff = ToBeQueued - queued

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      simulationResult: ToBeQueued,
      simulationDiff
    }))

    pendoTrack('Sending - Modal segmentation - result recipients', {
      IdMessage: idMessage,
      IsTheSame: simulationDiff === 0 ? 'True' : 'False',
      Result: simulationDiff
    })
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'sendingSegmentationSimulateCallback',
      Message: 'Errore in simulazione da modale di segmentazione',
      Data: JSON.stringify({ idSending })
    })

    set(modalSendingSegmentationState, prev => ({
      ...prev,
      simulationLoading: false,
      simulationLoaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const initFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async () => {
  try {
    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: false
    }))

    const { idSending } = await snapshot.getPromise(idsState)

    const resp = await getNoDisturbConfig(idSending)

    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: resp && resp.NoDisturbHours.length > 0,
      isFirstConfiguration: !resp,
      Start: resp ? getTimeObj(resp.NoDisturbHours[0].Start, 'T') : prev.Start,
      End: resp ? getTimeObj(resp.NoDisturbHours[0].End, 'T') : prev.End
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'getLastConfigurationsByInvioCallback',
      Message: 'getLastConfigurationsByInvioCallback'
    })

    set(fasciaDiNonDisturboState, prev => ({
      ...prev,
      enable: false
    }))
  }
  return true
}

export const setFasciaDiNonDisturboCallback = ({
  set,
  reset,
  snapshot
}) => async source => {
  set(pageState, prev => ({
    ...prev,
    loading: true
  }))
  try {
    const {
      Start,
      End,
      enable,
      isFirstConfiguration
    } = await snapshot.getPromise(fasciaDiNonDisturboState)
    reset(fasciaDiNonDisturboState)
    const { idSending, idMessage } = await snapshot.getPromise(idsState)
    if (!enable && !isFirstConfiguration) {
      await removeNoDisturbConfig(idSending)
      return true
    } else if (enable) {
      const { TimeZoneCode } = storeGet(STORE_KEY_LIST)

      const value = {
        TimeZone: TimeZoneCode,
        NoDisturbHours: [
          {
            Start:
              '1900-01-01T' +
              (Start.hours < 10 ? '0' + Start.hours : Start.hours) +
              ':' +
              (Start.minutes < 10 ? '0' + Start.minutes : Start.minutes) +
              ':00.000Z',
            End:
              '1900-01-01T' +
              (End.hours < 10 ? '0' + End.hours : End.hours) +
              ':' +
              (End.minutes < 10 ? '0' + End.minutes : End.minutes) +
              ':00.000Z'
          }
        ]
      }
      if (isFirstConfiguration) {
        await setNoDisturbConfig(idSending, value)
      } else {
        await updateNoDisturbConfig(idSending, value)
      }

      if (source === 'standBy') {
        pendoTrack(
          'evento anteprima invio:   attivazione FdND su Decidi più tardi',
          {
            idMessage: idMessage
          }
        )
      } else if (source === 'SendNow') {
        pendoTrack(
          'evento anteprima invio:- attivazione FdND su Invia Subito',
          {
            idMessage: idMessage
          }
        )
      } else if (source === 'scheduled') {
        pendoTrack(
          'evento anteprima invio: - attivazione FdND con  Schedulazione',
          {
            idMessage: idMessage
          }
        )
      }
    }

    set(pageState, prev => ({
      ...prev,
      loading: false
    }))
    return true
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'EmailSendingQueueManage',
      Method: 'getLastConfigurationsByInvioCallback',
      Message: 'getLastConfigurationsByInvioCallback'
    })

    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      loading: false
    }))
    return false
  }
}
